import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import LocalizedNavLink from '../../router/LocalizedNavLink';
import LogoutButtonComponent from '../../authentication/logout/LogoutButtonComponent';

class LoggedInComponent extends React.Component {
    render() {
        const { i18n, children } = this.props;
        return (
            <div className="flex-container-h flex-center-alt">
                <LocalizedNavLink
                    to={PATH.ACCOUNT_JACKPOT_PATH}
                    className="connexion connected hidden-mobonly">
                    {children}
                </LocalizedNavLink>
                <LogoutButtonComponent
                    className="deconnexion hidden-mobonly"
                    text={i18n.LOG_OUT}
                    isText
                />
            </div>
        );
    }
}

LoggedInComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV
    };
}

export default connect(mapStateToProps)(LoggedInComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedInComponent.js